import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { SicotService } from '../sicot.service';
import { TipoStruttura } from '../types/TipoStruttura';
import { TipoStrutturaDialogComponent } from './tipo-struttura-dialog/tipo-struttura-dialog.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-tipo-struttura',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    HeaderComponent,
    FooterComponent,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './admin-tipo-struttura.component.html',
  styleUrl: './admin-tipo-struttura.component.css',
})
export class AdminTipoStrutturaComponent implements OnInit {
  private readonly sicotService = inject(SicotService);
  private readonly dialog = inject(MatDialog);

  tipiStruttura: TipoStruttura[] = [];
  caricamento = true;
  errore: string | null = null;
  displayedColumns: string[] = ['id', 'codice', 'descrizione', 'actions'];

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.caricamento = true;
    this.errore = null;
    this.sicotService.getTipiStruttura().subscribe({
      next: (list) => {
        this.tipiStruttura = list ?? [];
        this.caricamento = false;
      },
      error: () => {
        this.errore = 'Errore nel caricamento dei tipi struttura.';
        this.caricamento = false;
      },
    });
  }

  aggiungi(): void {
    const ref = this.dialog.open(TipoStrutturaDialogComponent, {
      data: { tipoStruttura: null },
      width: '420px',
    });
    ref.afterClosed().subscribe((result) => {
      if (result) this.loadList();
    });
  }

  modifica(t: TipoStruttura): void {
    const ref = this.dialog.open(TipoStrutturaDialogComponent, {
      data: { tipoStruttura: t },
      width: '420px',
    });
    ref.afterClosed().subscribe((result) => {
      if (result) this.loadList();
    });
  }

  elimina(t: TipoStruttura): void {
    if (!confirm(`Eliminare il tipo struttura "${t.descrizione}" (id ${t.id})?`)) return;
    this.sicotService.deleteTipoStruttura(t.id).subscribe({
      next: () => this.loadList(),
      error: () => {
        this.errore = 'Errore durante l\'eliminazione del tipo struttura.';
      },
    });
  }
}
